
import {
 AUTHORITY, EXAMINEE, CURRENTUSER, MYEXAM, EXAMTIMELEFT, SUBMITCONFIRM, SERVERTIME, EXAMPAPER, SUBMITALLPAPER,
} from './types';


export default {
  [AUTHORITY](state, value) {
    state.authority = value;
  },
  [EXAMINEE](state, value) {
    state.examinee = value;
  },
  [CURRENTUSER](state, value) {
    state.currentUser = value;
  },
  [MYEXAM](state, value) {
    state.myExam = value;
  },
  [EXAMTIMELEFT](state, value) {
    state.examTimeLeft = value;
  },
  [SUBMITCONFIRM](state, value) {
    state.submitConfirm = value;
  },
  [SERVERTIME](state, value) {
    state.serverTime = value;
  },
  [EXAMPAPER](state, value) {
    state.examPaper = value;
  },
  [SUBMITALLPAPER](state, value) {
    state.submitAllPaper = value;
  },

};
